import type { CallInfo } from '@compass/client/types/call';
import React from 'react';

import { AudioPlayer } from '@/components/AudioPlayer/AudioPlayer';
import { AudioErrorBoundary } from '@/components/ErrorBoundary/AudioErrorBoundary';
import { useCallAudioAssets } from '@/hooks/useCallAudioAssets';

import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from './ui/dialog';

interface AudioPlayerDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  call: CallInfo | null;
}

export const AudioPlayerDialog: React.FC<AudioPlayerDialogProps> = ({
  open,
  onOpenChange,
  call,
}) => {
  const caseRecordId = call?.caserecord_id ?? null;
  const callId = call?.id ?? null;

  // Fetch full call details and extract audio assets for playback
  const { audioAssets, fullCall } = useCallAudioAssets(call, open);

  const phoneNumber = call?.input_data?.reporter_phone;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[550px]">
        <DialogHeader>
          <DialogTitle>Call Recording</DialogTitle>
          <DialogDescription>
            {phoneNumber ? `Reporter Phone : ${phoneNumber}` : 'Call recording playback'}
          </DialogDescription>
        </DialogHeader>
        <div className="mt-2">
          {caseRecordId && callId && audioAssets.length > 0 ? (
            <div className="rounded-md border overflow-hidden">
              <AudioErrorBoundary>
                <AudioPlayer
                  caseRecordId={caseRecordId}
                  callId={callId}
                  callDetails={{ sid: fullCall?.sid }}
                  assets={audioAssets}
                  autoPlay
                />
              </AudioErrorBoundary>
            </div>
          ) : (
            <div className="flex items-center justify-center py-8">
              <div className="h-5 w-5 animate-spin rounded-full border-2 border-muted-foreground border-t-transparent" />
            </div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};
